import { render, staticRenderFns } from "./EngagementMatrix.vue?vue&type=template&id=024bfeee&"
import script from "./EngagementMatrix.vue?vue&type=script&lang=js&"
export * from "./EngagementMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports